import { render, staticRenderFns } from "./Holdorder.vue?vue&type=template&id=32f9e7f9&scoped=true&"
import script from "./Holdorder.vue?vue&type=script&lang=js&"
export * from "./Holdorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9e7f9",
  null
  
)

export default component.exports